import axios from "axios";
import { config } from "../config/config";
import Cookies from "js-cookie";

const axiosInstanceCentralJson = axios.create({
  baseURL: config.central.url,
  timeout: 5000,
  withCredentials: true,
});

// Request interceptor
axiosInstanceCentralJson.interceptors.request.use(
  (config) => {
    config.headers["Content-Type"] = "application/json";
    const token = Cookies.get("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstanceCentralJson.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      handleUnauthorized();
      return Promise.resolve();
    }
    return Promise.reject(error);
  }
);

const handleUnauthorized = () => {
  // Remove with same parameters as set
  Cookies.remove("authToken", {
    domain: config.domain,
    path: "/",
    secure: config.ENVIRONMENT === "prod",
    sameSite: "Strict",
  });

  if (typeof window !== "undefined") {
    // Add timeout to ensure cookie is removed before redirect
    setTimeout(() => {
      window.location.href = "/";
    }, 100);
  }
};

export default axiosInstanceCentralJson;
